import React from "react";
import { useNavigate } from "react-router-dom";

const PublicLandingPage = () => {
  const navigate = useNavigate();

  const handleSignInClick = () => {
    // Navigate to /app to load the App component
    navigate("/app");
  };

  return (
    <div>
      <h1>Welcome to KICKS App</h1>
      <p>Discover how we make managing football teams easier!</p>
      <button onClick={handleSignInClick}>Sign In</button>
    </div>
  );
};

export default PublicLandingPage;
